import { render, staticRenderFns } from "./groups_list_item.vue?vue&type=template&id=21c672f4"
import script from "./groups_list_item.vue?vue&type=script&lang=js"
export * from "./groups_list_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports